import apiClient from './index';

/**
 * Notification API Service
 * Handles all API calls related to in-app notifications
 */

export const notificationApi = {
  /**
   * Get list of notifications
   * @param {Object} params - Query parameters
   * @param {boolean} params.is_read - Filter by read status
   * @param {number} params.page - Page number
   * @param {number} params.page_size - Items per page
   */
  getNotifications(params = {}) {
    return apiClient.get('/notifications/', { params });
  },

  /**
   * Get count of unread notifications
   */
  getUnreadCount() {
    return apiClient.get('/notifications/unread-count/');
  },

  /**
   * Mark a specific notification as read
   * @param {number} notificationId - Notification ID
   */
  markAsRead(notificationId) {
    return apiClient.patch(`/notifications/${notificationId}/read/`);
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead() {
    return apiClient.post('/notifications/mark-all-read/');
  },

  /**
   * Delete a specific notification
   * @param {number} notificationId - Notification ID
   */
  deleteNotification(notificationId) {
    return apiClient.delete(`/notifications/${notificationId}/delete/`);
  }
};

export const notificationSettingsApi = {
  getSettings() {
    return apiClient.get('/notification-settings/');
  },
  updateSettings(data) {
    return apiClient.patch('/notification-settings/', data);
  },
  sendVerification(email) {
    return apiClient.post('/notification-settings/send-verification/', { email });
  },
  confirmEmail(email, code, frequency, send_hour = 8, filter_preset_ids = [], send_day_of_week = 0) {
    return apiClient.post('/notification-settings/confirm-email/', { email, code, frequency, send_hour, filter_preset_ids, send_day_of_week });
  },
  quickSetupEmail(frequency, send_hour = 8, filter_preset_ids = [], send_day_of_week = 0) {
    return apiClient.post('/notification-settings/quick-setup/', { frequency, send_hour, filter_preset_ids, send_day_of_week });
  },
  updateEmail(id, data) {
    return apiClient.patch(`/notification-settings/email/${id}/`, data);
  },
  deleteEmail(id) {
    return apiClient.delete(`/notification-settings/email/${id}/`);
  },
  sendTestEmail(id) {
    return apiClient.post(`/notification-settings/email/${id}/test/`);
  },
  sendTestTelegram() {
    return apiClient.post('/telegram/test/');
  },
  generateDiscordToken(returnPath) {
    return apiClient.post('/discord/generate-token/', returnPath ? { return_path: returnPath } : {});
  },
  getDiscordConnectionStatus() {
    return apiClient.get('/discord/status/');
  },
  disconnectDiscord() {
    return apiClient.post('/discord/disconnect/');
  },
  toggleDiscord(isActive) {
    return apiClient.post('/discord/toggle/', { is_active: isActive });
  },
  sendTestDiscord() {
    return apiClient.post('/discord/test/');
  },
};

export default notificationApi;
